import { render } from "./layout-sider.vue?vue&type=template&id=1899d726"
import script from "./layout-sider.vue?vue&type=script&lang=js"
export * from "./layout-sider.vue?vue&type=script&lang=js"

import "./layout-sider.vue?vue&type=style&index=0&id=1899d726&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__